"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorRdfMetadataExtractPostAccepted = void 0;
const bus_rdf_metadata_extract_1 = require("@comunica/bus-rdf-metadata-extract");
const core_1 = require("@comunica/core");
/**
 * A comunica Post Accepted RDF Metadata Extract Actor.
 */
class ActorRdfMetadataExtractPostAccepted extends bus_rdf_metadata_extract_1.ActorRdfMetadataExtract {
    constructor(args) {
        super(args);
    }
    async test(_action) {
        return (0, core_1.passTestVoid)();
    }
    async run(action) {
        const metadata = {};
        const acceptPostHeader = action.headers?.get('accept-post');
        if (acceptPostHeader) {
            metadata.postAccepted = acceptPostHeader.split(/, */u);
        }
        return { metadata };
    }
}
exports.ActorRdfMetadataExtractPostAccepted = ActorRdfMetadataExtractPostAccepted;
//# sourceMappingURL=ActorRdfMetadataExtractPostAccepted.js.map